import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { startWith } from 'rxjs/operators';

@Component({
  selector: 'form-personal-information',
  templateUrl: './personal-information.component.html',
  styleUrls: ['./personal-information.component.scss'],
})
export class PersonalInformationComponent implements OnInit {
  private _formGroup: UntypedFormGroup;
  addressFormGroup: UntypedFormGroup;
  @Input() set formGroup(formGroup: UntypedFormGroup) {
    this._formGroup = formGroup;
    this.addressFormGroup = formGroup.get('address') as UntypedFormGroup;
  }
  get formGroup(): UntypedFormGroup {
    return this._formGroup;
  }
  @Input() isSwissOnly: boolean = true;
  @Input() isMandatory: boolean = true;
  @Input() isCleanable: boolean = false;
  
  constructor(
    private translateService: TranslateService,
    private renderer: Renderer2,
    ) { }

  ngOnInit(): void {
    this.translateService.onLangChange
      .pipe(startWith(this.translateService.currentLang))
      .subscribe(async () => {
        if (this._formGroup?.get('preferredLanguage'))
          this._formGroup.get('preferredLanguage')?.setValue(this.translateService.currentLang);
      });
  }

  // ngAfterViewInit() {
  //   setTimeout(() => {
  //     var element = this.renderer.selectRootElement('#AvsNumber');
  //     element.focus();
  //   }, 1000);
  // }

  reset() {
    this.formGroup.reset({},{ emitEvent: false });
    if (this._formGroup?.get('preferredLanguage'))
      this._formGroup.get('preferredLanguage')?.setValue(this.translateService.currentLang);
  }

  public dateOfBirthMax(): Date | null {
    const date = new Date();
    //date max equals 16 year ago as patient asking to open an EPR has to be older than 16
    return new Date(date.setFullYear(date.getFullYear() - 16) );
  }

  public get dateOfBirthMin(): Date {
    const min = new Date();
    min.setFullYear(min.getFullYear() - 200);
    return min;
  }

}
